// extracted by mini-css-extract-plugin
export var actions = "_q9-4";
export var item = "_q9-1";
export var price = "_q9-3";
export var quantity = "_q9-2";
export var table = "_q9-0";